.suspended-card-interaction:is(:hover, :focus-visible) {
  background: var(--color-accent) !important;
}

/* Keep the quantity/product badges and action buttons in their own palette. */
.suspended-card-interaction:is(:hover, :focus-visible) :is(
  strong,
  p,
  p span,
  [class*="text-(--muted-strong)"],
  [class*="text-(--muted-strong)"] span
) {
  color: var(--shell-nav-ink, #fff);
}
